export default __webpack_public_path__ + "assets/community-three-one-small.378eb1bfffd1f7fae843ba5bf601c67c.png";